<template>
  <div class="detail-container" >
    <Header @handler="handler" :userName="userName" :changeId="changeId"
    ></Header>
    <div class="detail" :class="{'detail-Tablet': isTablet}">
      <div class="detail-header" >
        <div class="detail-tabs">
          <Tabs
          @changeSubject="changeSubject"
          :subject_list="subject_list"
          :activeId="activeId"></Tabs>
        </div>
        <div class="detail-header_class">
          <span >{{className}}</span>
          <el-dropdown trigger="click" @command="changeClass" v-if="classList.length > 1">
            <span class="el-dropdown-link">
              <i
                class="el-icon-refresh el-icon--left"
              ></i
              >切换班级
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
              :class="{active:item.class_name===className}"
              v-for="(item,index) in classList" :key="index" :divided="index>0"
              :command="index"
              >{{item.class_name}}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      <!-- 测评列表 -->
      <div v-if="changeId===1"  v-loading="loading"
        element-loading-background="#fff" class="testList">
          <div class="practice-status">
            <div class="testStatus">
              <span :class="['practice-unfinished',
                {'active':testId===2}]" @click="changeTest(2)">查看未完成</span>
              <span :class="['practice-all',
                {'active':testId===1}]" @click="changeTest(1)">查看已完成</span>
            </div>
          </div>

          <div class="detail-wrap" v-if="testId==2">
            <div class="detail-wrap_di" >
              <img src="../images/di.png" alt="" />
            </div>
            <div class="detail-wrap_title">未完成的测评</div>
          </div>
          <unfinished-test :activeId="activeId" :unfinishedList="unfinishedList"
           v-if="testId==2" @applyOne='applyOne' :pageSize="pageSize"
            @changePageSize="changePageSize"
            @changeCurrent="changeCurrent"
            :total="total"></unfinished-test>

          <div class="detail-wrap" v-if="testId==1">
            <div class="detail-wrap_un"><img src="../images/di.png" alt="" /></div>
            <div class="detail-wrap_title">已完成的测评</div>
          </div>
          <finished-content :activeId="activeId" :finishedList="finishedList"
          v-if="testId==1"  @applyOne='applyOne' :pageSize="pageSize"
            @changePageSize="changePageSize"
            @changeCurrent="changeCurrent"
            ref="finishedContent"
            :total="total"></finished-content>
      </div>
      <!-- 预习记录 -->
      <div class="prepare-record" v-else-if="changeId===2"  v-loading="loading"
    element-loading-background="#fff">
        <div class="detail-wrap" >
        <div class="detail-wrap_di"><img src="../images/di.png" alt="" /></div>
        <div class="detail-wrap_title">我的预习记录</div>
        </div>
        <prepare-records
        :activeId="activeId"
        :prevList="prevList"
        @applyOne='applyOne' :pageSize="pageSize"
        @changePageSize="changePageSize"
        @changeCurrent="changeCurrent"
        :total="total"
        ></prepare-records>
      </div>
      <!-- 练习中心 -->
       <div class="prepare-record" v-else  v-loading="loading"
        element-loading-background="#fff">
        <div class="practice-center">
        <div class="practice-wrap" >
        <div class="practice-wrap_di"><img src="../images/di.png" alt="" /></div>
        <div class="practice-wrap_title">我的练习</div>
        </div>
        <div class="practice-status">
          <span :class="['practice-all',
          {'active':practiceId===0}]" @click="changePractice(0)">查看全部</span>
          <span :class="['practice-unfinished',
          {'active':practiceId===2}]" @click="changePractice(2)">仅看未完成</span>
        </div>
        </div>
        <practice-center
        :activeId="activeId"
        :prevList="practiceList"
        :total="total"
        ref="practiceCenter"
        @applyOne='applyOne' :pageSize="pageSize" @changePageSize="changePageSize"
        @changeCurrent="changeCurrent"
        ></practice-center>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import FinishedContent from '../components/finished-content.vue';
import UnfinishedTest from '../components/unfinished-test.vue';
import PrepareRecords from '../components/prepare-records.vue';
import PracticeCenter from '../components/practice-center.vue'
import Tabs from '../components/tabs.vue';
import Header from '../components/header.vue';
import api from '@/pages/uc-web/api/api';
import { userAgentType,isApp, jsBridgeForSSAI } from '@/utils/index.js';
import _ from 'lodash';

export default {
  name:'DlDetail',
  data() {
    return {
      userName: '',//用户名
      activeId: '0',// 当前点击的科目id
      list: [], // 测试列表
      preList:[],//预习列表
      praList:[],//练习列表
      params: {}, // 测试列表参数
      classList: [], // 班级列表
      subjectList: {}, // 科目列表
      className:'',// 显示班级名称
      class_name:'',//班级名
      class_id:'',
      lastInfo:{},//最后一次班级测评的信息
      loading:false,//加载
      changeId: Number(this.$route.query.changeId) || Number(localStorage.getItem('changeId')) || 2,// 头部tab Id
      showType: false,
      pageSize:10,
      currentPage:1,
      practiceId:0,//练习完成状态
      testId:2,
      total:0,
      pageCount:0,
      isTablet:false,
      isPad: /ipad|android/i.test(navigator.userAgent),
      userToken: '',
      schoolId: '',
      accountId: '',
      NoGroundUrl: '',
      groundUrl: '',
    };
  },
  components: {
    UnfinishedTest,
    FinishedContent,
    Tabs,
    Header,
    PrepareRecords,
    PracticeCenter
  },
  created() {
  },
  async mounted() {
    const params = JSON.parse(localStorage.getItem('BigLoginParams')) || {}
    this.isTablet=userAgentType().isTablet;
    this.activeId = params.subject_id || '0';
    if (this.$route.query.changeId) {
      this.activeId = '0';
    }
    console.log(this.activeId, '看看结果值activeId', params);
    let Id=window.location.search||'';
    window.getData=this.getToken;
    window.getUcInfo=this.getUcInfo
    if (isApp()) {
      jsBridgeForSSAI('getData', {
        key: 'user_token'
      },'getData');
      jsBridgeForSSAI('getData', {
        key: 'UCINFO'
      },'getUcInfo');
    }
    
    if ((!localStorage.getItem('user_token') && !localStorage.getItem('ddToken') )&& this.isPad) {
      console.log(this.isPad,88888888888);
      this.$router.push('/uc-web/login');
    }
    this.redirectToWeb()
    this.getStuInfoAfterLogin(this.changeId);
  },
  methods: {
    redirectToWeb() {
      console.log('redirectToWeb', window.innerWidth);
      if (window.innerWidth < 600 && !this.isPad) {
        window.location.href = `${window.location.protocol}//${window.location.host}/uc-mobile/center`;
      }
    },
    getToken(data) {
      if (data !== undefined) {
        const userToken = JSON.parse(data).data.user_token;
        localStorage.setItem('user_token', userToken)
        try {
          console.log( JSON.parse(data), userToken );
        }catch(e) {
          console.log(e)
      }
      }
    },
    getUcInfo(data) {
      if (data !== undefined) {
        // alert(data)
        const ucInfo = JSON.parse(data).data.UCINFO
        localStorage.setItem('real_name', ucInfo.real_name);
        localStorage.setItem('account_id', ucInfo.account_id);
        localStorage.setItem('school_id', ucInfo.school_id);
        localStorage.setItem('user_token', ucInfo.user_token);
        localStorage.setItem('school_nature_id', ucInfo.school_nature_id);
        this.schoolId = ucInfo.school_id;
        this.accountId = ucInfo.account_id;
      }
    },
    async getStuInfoAfterLogin(i){
      this.loading = true
      try {
        const params = {
        // school_id:2217,
        school_id:localStorage.getItem('school_id') || this.schoolId,
        // account_id:8885623813293003,
        account_id:localStorage.getItem('account_id') || this.accountId,
        type:i
        }
      const res = await api.getStuInfoAfterLogin(params)
      this.subjectList=res.data.subject_list||[];
      this.classList = res.data.class_list || []

      //获取上次测试的班级信息
      const result = await api.getLastInfo(params);
      this.lastInfo = result.data
      // console.log(result.data.class_name)
      this.className =
      result.data.class_name || this.classList[0].class_name || ''
      this.class_id =
      result.data.class_id || this.classList[0].class_id || ''
      } catch (error) {
      }
      this.loading=false;
      this.getTestInfo(i);
    },
    // 切换科目
    changeSubject(subjectId) {
      this.activeId = subjectId;
      if (this.changeId!==2 && this.changeId!==1) {
        this.$refs.practiceCenter.handleCurrentChange(1);
      }
      this.getTestInfo(this.changeId);
    },
    applyOne() {
      this.showType = true;
    },
    //获取预习/测评/练习列表
   async getTestInfo(i) {
    this.loading = true
    try {
      const params = {
        // school_id:2217,
        school_id:localStorage.getItem('school_id'),
        // account_id:8885623813293003,
        account_id:localStorage.getItem('account_id'),
        type:i,
        class_id:this.class_id,
        subject_id:this.activeId, //0 全部
        // task_status:this.practiceId,//0 全部 1已完成 2进行中
        task_status:this.practiceId,
        page_size:this.pageSize,
        curr_page:this.currentPage,
        sort:0
      }
      const res = await api.getStuTaskListById(params)
      this.userName = localStorage.getItem('real_name')
      if (i==2) {
        this.preList = res.data.list || []
      } else if(i==1){
        this.list=res.data.list || []
      }else{
        this.praList=res.data.list || []
      }
      this.total=res.data.total;
      this.pageCount=res.data.total_page;

      // this.subjectList = res.data.subject_list || []

      // //获取上次测试的班级信息
      // const result = await api.getLastInfo(params);
      // this.lastInfo = result.data
      // this.className =
      // result.data.class_name || this.classList[0].class_name || ''
    } catch (error) {
        console.log(error)
    } finally{
        this.loading = false
    }

  },
    // 切换班级
    changeClass(command) {
      this.className  = this.classList[command].class_name;
      this.class_id=this.classList[command].class_id;
      this.activeId = '0'
      this.pageSize=10;
      this.currentPage=1;
      this.getTestInfo(this.changeId);
    },
    // 头部tab切换
    handler(i) {
      this.changeId = i;
      this.activeId = '0';
      this.total=0;
      this.class_id='';
      this.className='';
      // this.getTestInfo();
      if(this.changeId===2){
        this.practiceId=0;
        //获取学生登陆后信息
        this.getStuInfoAfterLogin(2);
      }
      if (this.changeId===1) {
        this.practiceId=2;
        this.getStuInfoAfterLogin(1);
      }
      if (this.changeId===3) {
        this.practiceId=0;
        this.getStuInfoAfterLogin(3);
      }
        // this.getTest()
    },
    //更改每页显示个数,重新发请求
    changePageSize(val){
      this.pageSize = val;
      this.getTestInfo(this.changeId);
    },
    changeCurrent(val){
      this.currentPage=val;
      this.getTestInfo(this.changeId);
    },
    // 切换练习状态
    changePractice(i){
      this.practiceId = i;
      this.$refs.practiceCenter.handleCurrentChange(1);
      this.getTestInfo(this.changeId);
    },
    // 切换测评状态
    changeTest(i){
      this.testId = i;
      this.practiceId=this.testId;
      if (this.testId==1) {
        this.$nextTick(() => {
          this.$refs.finishedContent && this.$refs.finishedContent.handleCurrentChange(1);
        });
      }
      this.getTestInfo(this.changeId);
    }
  },
  activated() {
    if (!this.showType) {
      if(Number(localStorage.getItem('changeId'))===1){
        this.activeId = '0'
        this.changeId = 1;
        this.className = ''
        this.pageSize = 10
        // this.getTestInfo();
      }else if(Number(localStorage.getItem('changeId'))===3){
         this.activeId = '0'
        this.changeId = 3;
        this.className = ''
        this.pageSize = 10
        // this.getTest();
      }else{
        this.activeId = '0'
        this.changeId = 2;
        this.className = ''
        this.pageSize = 10
      }
    }
      this.showType = false
  },
   computed: {
     // 获取展示的科目列表
    subject_list() {
      const newData = [];
      Object.keys(this.subjectList).forEach((key, index) => {
        newData.push({
          subjectId: key,
          subjectName: this.subjectList[key],
        });
     })
      return newData
    },
     //测评列表渲染
    testList() {
      let arrList =  this.list.filter(item=>item.class_name!=='')
       return arrList.sort(function(a, b) {
          return b.created < a.created ? -1 : 1
      })
    },
    //预习列表渲染
    prevList(){
      let arrList =  this.preList.filter(item=>item.class_name!='')
       return arrList.sort(function(a, b) {
          return b.created < a.created ? -1 : 1
      })
    },
    // 未完成列表
    unfinishedList() {
      return this.testList.filter(item=>item.evaluate_status==2);
    },
    // 已完成列表
    finishedList() {
      let arr = this.testList.filter(item=>item.evaluate_status==1);
      return arr.sort(function(a, b) {
          return b.end_time < a.end_time ? -1 : 1
      })
    },
    // 练习列表渲染
    practiceList(){
      let arrList =  this.praList.filter(item=>item.class_name!='');
       return arrList.sort(function(a, b) {
          return b.created < a.created ? -1 : 1
      })
    }
  },
};
</script>

<style lang="scss" scoped>
.detail-container {
  padding-top: 64px;
  padding-bottom:54px ;
  font-family: PingFangSC-Medium, PingFang SC;
}
.detail-Tablet{
  width: 100% !important;
  // margin: 0;
}
.detail {
  width: 1118px;
  margin: 16px auto;
  background: #fff;
  padding: 0 19px 0 20px;
  font-family: PingFangSC-Medium, PingFang SC;
  &-header {
    height: 88px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    background-color: #fff;
    border-bottom: 1px solid #ebeef5;
    &_class {
      span {
        font-size: 16px;
        font-weight:500;
        color: #000000;
      }
    }
    .el-dropdown-link {
      font-size: 14px;
      color: #1989FA;
      margin-left:22px;
      cursor: pointer;
    }
  }
  &-wrap {
    width: 100%;
    height: 51px;
    position: relative;
    &_di {
      margin-top: 24px;
    }
    &_un {
      margin-top: 24px;
    }
    &_title {
      position: absolute;
      font-size: 17px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.8);
      top: 5px;
      left: 13px;
    }
  }
}
.practice-center{
  height: 77px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;

  .practice-wrap_title{
    position: absolute;
    left: 16px;
    top: 25px;
    font-size: 17px;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.8);
  }
}
.practice-status{
  position: relative;
    font-size: 13px;
    color: #303133;
    .practice-all{
      display: inline-block;
      width: 84px;
      height: 28px;
      text-align: center;
      line-height: 28px;
      border: 1px solid #C0C4CB;
    }
     .practice-unfinished{
      display: inline-block;
      width: 84px;
      height: 28px;
      text-align: center;
      line-height: 28px;
      border: 1px solid #C0C4CB;
    }
    .active{
    color: #1989FA;
    border: 1px solid #1989FA;
    }
}
.testStatus{
  display: inline-block;
  height: 30px;
  position: absolute;
  right: 0;
  z-index: 999;
  // border-right: 1px solid #C0C4CB;
  // border-left: 1px solid #C0C4CB;
}
.testList{
  padding-top: 25px;
  min-height: 715px;
}
.el-dropdown-menu{
font-weight: 500;
color: #010101;
}
.el-icon-refresh:before{
  font-weight:500 ;
}
.active{
  color: #1989FA;
}

</style>
